import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import siteConfig from '../../../../config';

import MdClose from 'react-icons/lib/md/close';

import { media, mixins } from '../../../../styles';

import Button from '../../../ui/Button';
import IconButton from '../../../ui/IconButton';

import Body from '../../../typography/Body';
import Caption from '../../../typography/Caption';
import Headline from '../../../typography/Headline';
import Title from '../../../typography/Title';

import CuratedInfoBlock from './CuratedInfoBlock';
import DeliveryOptions from './DeliveryOptions';

import { actions as analyticsActions } from '../../../../actions/analytics';


const TRANSITION_DELAY = 225;

const Backdrop = glamorous.div(props => ({
  position: 'absolute',
  ...mixins.fillToParent,
  backgroundColor: 'rgba(0,0,0,0.54)',
  opacity: props.isOpen ? 1 : 0,
  transition: `opacity ${TRANSITION_DELAY}ms cubic-bezier(0, 0, 0.2, 1) 0ms`,

  [media('sm', { isMax: true })]: {
    zIndex: 101,
    position: 'fixed',
  },
}));

const Container = glamorous.div(props => ({
  overflow: 'auto',
  position: 'absolute',
  ...mixins.fillToParent,
  width: '90%',
  left: '10%',
  backgroundColor: '#fff',
  transition: `transform ${TRANSITION_DELAY}ms cubic-bezier(0, 0, 0.2, 1) 0ms`,
  transform: props.isOpen ? 'translateX(0)' : 'translateX(100%)',

  [media('sm', { isMax: true })]: {
    width: '100%',
    left: 0,
  },
}));

const Header = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',
  padding: 8,
  borderBottom: `1px solid ${props.theme.default.lightest}`,
}));

const EventTitle = glamorous.div(props => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  borderLeft: `5px solid ${props.tgColor}`,
  marginLeft: 8,
  paddingLeft: 8,
}));

const Block = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 16px',
  borderBottom: `1px solid ${props.theme.default.lightest}`,
}));

const Row = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: props.justifyContent,
  marginBottom: props.marginBottom,
}));

const RowQuantity = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',

  padding: '8px 16px',

  [media('xs', { isMax: true })]: {
    ...mixins.scroll,
    flexWrap: 'nowrap',
  },
}));

const Spacer = glamorous.div({
  display: 'none',

  [media('xs', { isMax: true })]: {
    display: 'block',
    paddingLeft: 8,
  },
});

const styleHeadline = {
  fontSize: '1.25em',
  marginBottom: 0,
  lineHeight: '1.5em',
};

const styleQuantityButton = {
  marginRight: 8,
  marginBottom: 8,
  boxShadow: '0 0 1px 0px rgba(0,0,0,0.54)',
};

const styleContainer = {
  position: 'relative',
  backgroundSize: 'cover',
  height: 270,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundColor: '#444',
};

const styleHeader = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 15%,rgba(0,0,0,0.6) 50%,rgba(0,0,0,1) 100%)',
  color: '#fff',
};

const noop = () => {};

const stopPropagation = e => e.stopPropagation();

class CheckoutSummary extends React.PureComponent {
  static propTypes = {
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    onSelectQuantity: PropTypes.func,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    onHide: noop,
    onShow: noop,
    onSelectQuantity: noop,
    isOpen: false,
  };

  state = {
    isOpen: !!this.props.selectedTicket,
    isReady: false,
    hasFailedToCheckout: false,
    selectedQuantity: null,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedTicket && nextProps.selectedTicket !== this.props.selectedTicket) {
      this.showContainer();
    }
  }

  setIsOpen = isOpen => this.setState({ isOpen });
  setIsReady = isReady => this.setState({ isReady });
  setSelectedQuantity = (selectedQuantity) => {
    this.setState({ selectedQuantity });
    this.props.onSelectQuantity(selectedQuantity);
  };

  showContainer = () => {
    this.setIsReady(true);
    setTimeout(() => this.setIsOpen(true), TRANSITION_DELAY);
    this.props.onShow();

    setTimeout(() => {
      window.addEventListener('click', this.hideContainer);
    }, TRANSITION_DELAY);
  };

  hideContainer = () => {
    this.setIsOpen(false);
    this.setSelectedQuantity(null);

    setTimeout(() => {
      this.setIsReady(false);
      this.props.onHide();
    }, TRANSITION_DELAY);

    window.removeEventListener('click', this.hideContainer);
  };

  handleClickClose = (e) => {
    e.stopPropagation();
    this.props.analyticsRecordActionRequest('ticket','close', '');
    this.hideContainer();
  };

  handleClickQuantity = (e, quantity) => {
    this.setState({
      hasFailedToCheckout: false,
    });

    this.setSelectedQuantity(quantity);

    const { selectedTicket }= this.props;
    this.props.analyticsViewTicketRequest(selectedTicket, quantity);
    this.props.analyticsRecordActionRequest('ticket','setquantity', quantity);
  };

  handleClickCheckout = (e) => {
    if (!this.state.selectedQuantity) {
      this.setState({
        hasFailedToCheckout: true,
      });

      return;
    }

    const {
      selectedTicket,
    } = this.props;

    this.props.onClickBuyButton(selectedTicket, this.state.selectedQuantity);
    this.form.submit();
  };

  renderHeader() {
    const { selectedTicket } = this.props;

    if (selectedTicket.section && selectedTicket.section.vfsUrl) {
      return this.renderHeaderImage();
    }

    return (
      <Header>
        <IconButton
          color="primary"
          size="large"
          onClick={this.handleClickClose}
          label={<MdClose />}
        />

        <EventTitle tgColor={selectedTicket.tgColor}>
          <Headline style={styleHeadline}>
            {selectedTicket.getSectionDisplayName()}
          </Headline>
          <Caption>
            Row {selectedTicket.getRowDisplayName()} &bull; {selectedTicket.tgQty} Tickets
          </Caption>
        </EventTitle>
      </Header>
    );
  }

  renderHeaderImage() {
    const { selectedTicket } = this.props;
    const styleContainerBg = {
      ...styleContainer,
      backgroundImage: `url('${selectedTicket.section.vfsUrl}')`,
    };

    return (
      <div style={styleContainerBg}>
        <IconButton
          color="primary"
          size="large"
          onClick={this.handleClickClose}
          label={<MdClose color="#fff" />}
          style={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: 'rgba(0,0,0,0.27)',
          }}
        />
        <Header style={styleHeader}>
          <EventTitle tgColor={selectedTicket.tgColor}>
            <Headline style={styleHeadline}>
              {selectedTicket.getSectionDisplayName()}
            </Headline>
            <Caption>
              Row {selectedTicket.getRowDisplayName()} &bull; {selectedTicket.tgQty} Tickets
            </Caption>
          </EventTitle>
        </Header>
      </div>
    );
  }

  renderSelectQuantity() {
    const { selectedTicket } = this.props;
    const { hasFailedToCheckout } = this.state;

    return (
      <Block style={{ padding: 0}}>
        <Headline
          marginTop={8}
          marginBottom={8}
          color={hasFailedToCheckout ? 'danger' : undefined}
          style={{
            display: 'flex',
            paddingTop: 8,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          <div
            className={hasFailedToCheckout ? 'animated tada' : undefined}
            style={{
              animationDuration: '800ms',
            }}
          >
            How many tickets?
          </div>
        </Headline>
        <RowQuantity>
          {selectedTicket.splits.map(quantity => (
            <IconButton
              key={quantity}
              label={quantity}
              onClick={e => this.handleClickQuantity(e, quantity)}
              size="large"
              color="primary"
              isRaised={quantity === this.state.selectedQuantity}
              style={styleQuantityButton}
            />
          ))}
          <Spacer />
        </RowQuantity>
      </Block>
    );
  }

  renderEstimatedSubtotal() {
    const { selectedTicket } = this.props;
    const { selectedQuantity } = this.state;

    const totalPrice = selectedQuantity ? selectedTicket.tgPrice * selectedQuantity : null;

    return (
      <Block>
        <Headline marginTop={8} marginBottom={16}>
          Estimated Subtotal
        </Headline>

        <Title marginTop={0} marginBottom={16}>
            ${totalPrice || '--'}
        </Title>

        <Row justifyContent="space-between" marginBottom={16}>
          <Caption>{selectedQuantity || 'Qty'} x ${selectedTicket.tgPrice}/ea</Caption>
          <Caption>Not including fees</Caption>
        </Row>
        <form action="https://checkout.simplifytickets.com/Checkout/Order" method="POST" ref={form => {this.form=form}}>
                <input type="hidden" name="WebsiteConfigId" value={ siteConfig.websiteConfigId } />
                <input type="hidden" name="Cart.LineItems[0].CurrencyCode" value={ siteConfig.c3CurrencyCode } />
                <input type="hidden" name="Cart.LineItems[0].UnitPrice" value={ selectedTicket.tgPrice } />
                <input type="hidden" name="Cart.LineItems[0].TicketGroupId" value={ selectedTicket.tgID } />
                <input type="hidden" name="Cart.LineItems[0].Quantity" value={ selectedQuantity } />
        </form>
        <Button
          color="accent"
          label="Go to secure checkout"
          style={{
            marginBottom:8,
            height: 40,
          }}
          isRaised
          onClick={this.handleClickCheckout}
          disabled={this.state.hasFailedToCheckout}
        />
      </Block>
    );
  }

  renderCuratedInfoBlock() {
    return (
      <CuratedInfoBlock
        hasBorder
        ticket={this.props.selectedTicket}
      />
    );
  }

  renderDeliveryOptions() {
    const { isElectronic, isInstant, isMobile } = this.props.selectedTicket.tgClientData;

    if (!isElectronic && !isInstant && !isMobile) {
      return null;
    }

    return (
      <Block>
        <Headline marginTop={8} marginBottom={16}>
          Delivery Options
        </Headline>

        <DeliveryOptions
          {...this.props.selectedTicket.tgClientData}
        />
      </Block>
    );
  }

  renderAdditionalNotes() {
    const { selectedTicket } = this.props;

    if (!selectedTicket.tgNotes) {
      return null;
    }

    return (
      <Block>
        <Headline marginTop={8} marginBottom={16}>
          Additional Notes
        </Headline>

        <Body>{selectedTicket.tgNotes}</Body>
      </Block>
    );
  }

  render() {
    const {
      isReady,
      isOpen,
    } = this.state;

    if (!isReady) {
      return null;
    }

    return (
      <Backdrop
        isOpen={isOpen}
        onClick={this.handleClickClose}
      >
        <Container
          isOpen={isOpen}
          onClick={stopPropagation}
        >
          {this.renderHeader()}
          {this.renderSelectQuantity()}
          {this.renderEstimatedSubtotal()}
          {this.renderCuratedInfoBlock()}
          {this.renderDeliveryOptions()}
          {this.renderAdditionalNotes()}
        </Container>
      </Backdrop>
    );
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => bindActionCreators({
  ...analyticsActions,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSummary);


// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/CheckoutSummary.js